import { post } from "shared/lib/api"

const logAction = (eventName, params = {}) => {
  Object.assign(params, {
    path: window.location.href,
    referrer: document.referrer,
  })
  return post(`/partner_log_event?item=${eventName}`, params)
}

export default logAction
